import Grid from '@mui/material/Grid2';
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from '@mui/material/Select';
import AnalysisFilterViewModel from "../ViewModels/AnalysisFilterViewModel";
import { useEffect, useState } from 'react';

interface IProps {
    state: AnalysisFilterViewModel;
    updateState: (properties: Partial<AnalysisFilterViewModel>, callback?: (newState?: AnalysisFilterViewModel) => void) => Promise<void>;
}

export default function SurveyPeriod({ state, updateState }: IProps) {
    const [startPeriods, setStartPeriods] = useState<number[]>([]);
    const [endPeriods, setEndPeriods] = useState<number[]>([]);

    const handleChange = (event: SelectChangeEvent<number>) => {
        var value = Number.parseInt(event.target.value as string)

        switch (event.target.name) {
            case "startPeriod":
                updateState({
                    surveyPeriodStart: value,
                })
                break;
            case "endPeriod":
                updateState({
                    surveyPeriodEnd: value,
                })
                break;
        }
    }

    useEffect(() => {
        let startPeriods: number[] = []
        for (var i = 0; i <= state.surveyPeriodEnd; i++) {
            startPeriods.push(i)
        }

        let endPeriods: number[] = [];
        for (var i = state.surveyPeriodStart; i <= 23; i++) {
            endPeriods.push(i)
        }

        setStartPeriods(startPeriods)
        setEndPeriods(endPeriods)
    }, [state.surveyPeriodStart, state.surveyPeriodEnd])

    return (
        <Grid container component={Paper} size={12} padding={2}>
            <Grid container size={12}>
                <Typography>Survey Period Start</Typography>
                <Grid size={12}>
                    <Select
                        name="startPeriod"
                        value={state.surveyPeriodStart}
                        onChange={handleChange}>
                        {startPeriods.map((x: number) => {
                            return <MenuItem key={x} value={x}>
                                {("0" + x + ":00").slice(-5)}
                            </MenuItem>;
                        }
                        )}
                    </Select>
                </Grid>
            </Grid>
            <Grid container size={12}>
                <Typography>Survey Period End</Typography>
                <Grid size={12}>
                    <Select
                        name="endPeriod"
                        value={state.surveyPeriodEnd}
                        onChange={handleChange}>
                        {endPeriods.map((x: number) => {
                            return <MenuItem key={x} value={x}>
                                {("0" + (x+1) + ":00").slice(-5)}
                            </MenuItem>;
                        }
                        )}
                    </Select>
                </Grid>
            </Grid>
        </Grid>
    )
}
